import React from 'react';
import styles from './PermitsByTransport.module.scss';
import { Empty, Spin } from 'antd';
import CardPermits from '../CardPermits/CardPermits';
import usePermits from '../../../../shared/api/usePermits';
import { useSelector } from 'react-redux';
import useTransportPermitsMatch from '../../../../shared/hooks/useTransportPermitsMatch';

const PermitsByTransport = ({ transportId, ...props }) => {
  const { AllowTransportPermit } =
    useSelector((state) => state.authentication.userInfo) || {};

  const match = useTransportPermitsMatch();

  const urlCompanyId = match?.params.companyId
    ? Number(match.params.companyId)
    : null;

  const { data, isFetching } = usePermits(
    { transportId, serviceCompanyId: urlCompanyId },
    { enabled: Boolean(transportId && AllowTransportPermit && urlCompanyId) }
  );

  return (
    <div className={styles.root}>
      <div className={styles.header}>Пропуска</div>
      <div className={styles.content}>
        {isFetching ? (
          <Spin />
        ) : !!data?.length && AllowTransportPermit ? (
          data?.map((permit) => <CardPermits permit={permit} key={permit.id} />)
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              !AllowTransportPermit
                ? 'У вас нет доступа для получения пропусков!'
                : 'У данного ТС нет пропусков'
            }
          />
        )}
      </div>
    </div>
  );
};

export default PermitsByTransport;
